require('../../vendor/chosen.jquery.min.js');

$('.chosen-select').chosen({
    disable_search_threshold: 10
});


//////////////////
// WEBPACK FOOTER
// ./js/components/plugins/chosen.js
// module id = 2
// module chunks = 0